module.exports = __webpack_public_path__ + "img/piaui.52b79d41.jpg";